( function( $, window ) {
	'use strict';

	$( function() {
		const interval = 250;
		const visibleHeight = 400;
		const activeClass = 'sticky-header-active';
		const $body = $( 'body' );
		let didScroll = false;

		$( window ).on( 'scroll', function() {
			didScroll = true;
		} );

		setInterval( function() {
			if ( didScroll ) {
				handleScroll();
				didScroll = false;
			}
		}, interval );

		const handleScroll = () => {
			const currentScrollTop = ( $( window ).scrollTop() || $( 'body' ).scrollTop() );

			if ( currentScrollTop > visibleHeight ) {
				if ( ! $body.hasClass( activeClass ) ) {
					$body.addClass( activeClass );
				}
			} else {
				if ( $body.hasClass( activeClass ) ) {
					$body.removeClass( activeClass );
				}
			}
		};

		$( window ).trigger( 'scroll' );
	} );
} )( jQuery, window );
